import { headerStyles as styles } from "@waytek/Overrides/Widgets/InvoiceDetails/InvoiceDetailHeader";
import { clearBtnStyle, removeBtnFocusBorder } from "@waytek/Utilities/styleguide/btnIcon";
import { mediaQueriesBP } from "@waytek/Utilities/variables";
import { css } from "styled-components";

styles.headerGridContainer = {
    ...styles.headerGridContainer,
    gap: 0,
    css: css`
        margin-bottom: 10px;

        ${mediaQueriesBP.minMD} {
            margin-bottom: 20px;
        }
    `,
    offsetCss: css`
        justify-content: flex-start;

        ${mediaQueriesBP.minMD} {
            justify-content: flex-end;
        }
    `,
};

styles.allowPrintImageOnPdfCheckbox = {
    ...styles.allowPrintImageOnPdfCheckbox,

    css: css`
        z-index: 1000;

        @media print {
            display: none;
        }
    `,
};

styles.allowPrintImageGridItem = {
    ...styles.allowPrintImageGridItem,
    width: [12, 12, 12, 3, 3],
    css: css`
        justify-content: flex-start;

        ${mediaQueriesBP.minMD} {
            justify-content: flex-end;
        }
    `,
};

styles.logoGridItem = {
    ...styles.logoGridItem,
    width: 0,
    printWidth: 12,

    css: css`
        padding: 0;
    `,
};

styles.logoWrapper = {
    ...styles.logoWrapper,
    css: css`
        text-align: center;
    `,
};

styles.logo = {
    ...styles.logo,
    width: 240,
    css: css`
        max-width: 240px;
    `,
};

styles.narrowOverflowMenu = {
    ...styles.narrowOverflowMenu,
    cssOverrides: {
        wrapper: css`
            button {
                ${clearBtnStyle}
                ${removeBtnFocusBorder}
            }
        `,
    },
};

styles.belowLogoTxt = {
    ...styles.belowLogoTxt,
    as: "b",
    css: css`
        display: block;
    `,
};

styles.buttonGridItem = {
    ...styles.buttonGridItem,
    css: css`
        justify-content: flex-end;
    `,
    width: [2, 2, 2, 6, 6],
};

styles.titleGridItem = {
    ...styles.titleGridItem,
    width: [10, 10, 10, 6, 6],
};

styles.title = {
    ...styles.title,
    variant: "h1",
    as: "h1",

    css: css`
        margin-bottom: 0;
        font-size: 36px;

        ${mediaQueriesBP.maxMD} {
            font-size: 26px;
        }

        @media print {
            font-size: 26px;
            line-height: normal;
            margin-bottom: 4px;
        }
    `,
};
